// fonts.ts
const fonts = {
  primary: "'Untitled Sans', sans-serif",
  secondary: "'Publico Banner', serif",
};

export default fonts;
